// W47b (2026-10-21): the approved "Eligibility check" card (data-component
// "gift-eligibility") from the W47 `reasons[]`. Each check is passed (ok
// true), failed (ok false) or not checkable on this deployment (ok null);
// the PROGRAM_LIMITS line keeps its approved place as the closing note.
// The summary line is the one honest sentence: "Eligible", "Not eligible:
// <reason>" or "Eligibility unknown: missing <inputs>".
import type { ReactNode } from 'react';
import { Icon } from '../../_shared/IconSprite.js';
import { eligibilitySummary, type GiftEligibilityReason, type GiftEligibilityView } from '../liveModel.js';

const PROGRAM_LIMITS = 'PROGRAM_LIMITS';

function stateOf(reason: GiftEligibilityReason): 'passed' | 'failed' | 'unknown' {
  if (reason.ok === true) return 'passed';
  if (reason.ok === false) return 'failed';
  return 'unknown';
}

export function LiveGiftEligibility({ view }: { view: GiftEligibilityView }): ReactNode {
  const rows = view.reasons.filter(r => r.code !== PROGRAM_LIMITS);
  const limits = view.reasons.find(r => r.code === PROGRAM_LIMITS);
  const summary = eligibilitySummary(view);
  return (
    <section className="card" data-component="gift-eligibility" data-testid="gifts-live-eligibility" data-eligible={view.eligible === null ? 'null' : String(view.eligible)}>
      <div className="section-heading">
        <h3>Eligibility check</h3>
        <span>{view.source ?? 'HubSpot contact'}</span>
      </div>
      <div className="gift-eligibility">
        <p className="gift-eligibility-summary" data-testid="gifts-eligibility-summary">{summary}</p>
        {rows.map(reason => {
          const state = stateOf(reason);
          return (
            <div key={reason.code} className={`gift-check ${state}`} data-testid="gifts-eligibility-check" data-state={state}>
              {state === 'passed' ? <Icon id="check" /> : <span className="gift-check-mark" aria-hidden="true">{state === 'failed' ? '✗' : '?'}</span>}
              <span>
                {reason.label}
                {reason.detail ? <small> · {reason.detail}</small> : null}
              </span>
            </div>
          );
        })}
        <p>{limits?.label ?? 'Actual gift limits, intervals and approvals are supplied by the gift program.'}{limits?.detail ? ` (${limits.detail})` : ''}</p>
      </div>
    </section>
  );
}
